<form action="auth-dialog_submit" method="get" accept-charset="utf-8">
  @switch (concern) { @case ('login') {
  <h1>{{ 'Login' | translate }}</h1>

  <p>
    {{ 'This content is protected and requires authentication.' | translate }}
  </p>
  } @case ('delete-annotation') {
  <h1>{{ 'Delete annotation' | translate }}</h1>

  <p>
    {{ 'Are you sure you want to delete this annotation forever?' | translate }}
  </p>
  <p>
    {{ 'If you are sure, enter your username and password to confirm.' | translate }}
  </p>
  } }

  <k-input
    [label]="'Username' | translate"
    type="username"
    (valueChanged)="data.username = $event.value"
  />
  <k-input
    [label]="'Password' | translate"
    type="password"
    (valueChanged)="data.password = $event.value"
  />

  @if (loginFailed) {
  <p style="color: red">{{ 'Login failed' | translate }}</p>
  }

  <k-button-row>
    <!--<k-button
      (click)="dialogRef.close(false)"
      [disabled]="waitingForResponse"
      type="outlined-secondary"
      full-width
      >{{ 'Cancel' | translate }}</k-button
    >-->
    <k-button
      (click)="login()"
      [disabled]="data.username.length === 0 || data.password.length === 0 || waitingForResponse"
      full-width
      type="solid-primary"
    >
      @switch (concern) { @case ('login') {
      {{ 'Login' | translate }}
      } @case ('delete-annotation') {
      {{ 'Delete forever' | translate }}
      } }
    </k-button>
  </k-button-row>
</form>
